<template>
  <v-row>
    <v-col cols="12">
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="date"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="date"
            :label="$t('selectDate')"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            :disabled="disabled"
            :rules="[notEmpty]"
            id="alert-date"
          />
        </template>
        <v-date-picker
          @click:date="$refs.menu.save(date)"
          v-model="date"
          :locale="$t('javascriptLocale')"
          :min="new Date().toISOString().substring(0, 10)"
          no-title
          scrollable
          :rules="[notEmpty]"
        />
      </v-menu>
    </v-col>
    <v-col cols="12">
      <v-textarea
        v-model="text"
        :label="$t('alertText')"
        :disabled="disabled"
        :rules="[notEmpty]"
        counter
        no-resize
        id="alert-text"
        rows="5"
      />
    </v-col>
    <v-col cols="12">
      <v-checkbox
        v-model="exportToCalendar"
        :label="$t('calendar.export')"
        hide-details
        dense
        :disabled="disabled"
      ></v-checkbox>
    </v-col>
    <v-col cols="12" v-if="canCreateCalendarEvent">
      <v-checkbox
        v-model="addToOutlook"
        :label="$t('calendar.addToOutlook')"
        hide-details
        dense
        :disabled="disabled"
      ></v-checkbox>
    </v-col>
  </v-row>
</template>

<script>
import rules from '@/utils/rules'
import { mapGetters } from 'vuex'

export default {
  props: {
    operators: Array,
    disabled: Boolean,
  },
  data() {
    return {
      alert: {
        date: '',
        text: '',
        exportToCalendar: false,
        addToOutlook: false,
      },
      date: '',
      text: '',
      exportToCalendar: false,
      addToOutlook: false,
      menu: false,
      validAlertForm: false,
    }
  },
  methods: {
    ...rules,
  },
  computed: {
    ...mapGetters(['msalInstance', 'externalAuthConfig']),
    canCreateCalendarEvent() {
      return this.msalInstance && this.externalAuthConfig?.calendarEnabled
    },
  },
  watch: {
    date: function (newValue) {
      if (newValue) {
        this.alert.date = newValue
        this.$emit('setAlert', this.alert)
      }
    },
    text: function (newValue) {
      if (newValue) {
        this.alert.text = newValue
        this.$emit('setAlert', this.alert)
      }
    },
    exportToCalendar: function (newValue) {
      this.alert.exportToCalendar = newValue
      this.$emit('setAlert', this.alert)
    },
    addToOutlook: function (newValue) {
      this.alert.addToOutlook = newValue
      this.$emit('setAlert', this.alert)
    },
  },
}
</script>
